import axios, { AxiosResponse } from 'axios';
import { AuthData, AuthResponse, NewAuthData } from '../types/api/authApi';

const API_URL = process.env.REACT_APP_API_URL + 'auth';

const customHeaders = {
  'Content-Type': 'application/json'
};

// Sign in function with typed parameters and response
export const signIn = async (data: AuthData): Promise<AxiosResponse<AuthResponse>> => {
  try {
    const response = await axios.post(API_URL + '/login', data, { headers: customHeaders });
    return response;
  } catch (error: any) {
    console.error('Error fetching auth:', error);
    // You can toast an error message if needed
    // toast.error(error?.response?.data?.msg);
    throw error;
  }
};

// Add a new authentication function with typed parameters and response
export const addAuth = async (newAuth: NewAuthData): Promise<AxiosResponse<AuthResponse>> => {
  try {
    const response = await axios.post(API_URL + '/register', newAuth, { headers: customHeaders });
    return response;
  } catch (error: any) {
    // You can toast an error message if needed
    // toast.error(error?.response?.data?.msg);
    console.error('Error adding auth:', error);
    throw error;
  }
};
